export default function(num) {
    function cleanseNumber() {
        if (typeof num == 'number') {
            return num;
        }

        if (typeof num == 'string') {
            num = parseFloat(num.replace(/[^\d.-]/g, ''));

            if (isNaN(num)) {
                return 0;
            }

            return num;
        }

        return 0;
    }
    return cleanseNumber(num);
}